module.exports = __webpack_public_path__ + "images/talkingDogHome.df9eed65.svg";